/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".user-popup[_ngcontent-%COMP%]{position:absolute;background:#191919;border-radius:5px;box-shadow:2px 2px 8px #1f211f;padding:14px;color:#fff;z-index:50;right:20px}.user-popup[_ngcontent-%COMP%]   i.icon[_ngcontent-%COMP%]{color:grey!important}.user-popup[_ngcontent-%COMP%]   .ui.button[_ngcontent-%COMP%]{margin-top:8px;margin-bottom:8px}.user-popup[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0}"];
export { styles as styles };
